/**
 * Scroll-based Fog Effect
 * Content at bottom of viewport starts foggy, becomes crystal clear as you scroll to it
 * Like approaching through fog - fog clears as you get closer
 */

export const initScrollFogEffect = () => {
  const applyFogEffect = () => {
    // Selectors for elements that should have fog effect
    const selectors = [
      '.chat-messages > *',
      '.message-wrapper',
      'section > *',
      '.feature-card',
      '.step-column',
      '.settings-section',
      '.document-item'
    ];

    const elements = document.querySelectorAll(selectors.join(', '));
    
    // Get viewport dimensions
    const viewportHeight = window.innerHeight;
    
    elements.forEach(element => {
      const rect = element.getBoundingClientRect();
      const elementTop = rect.top;
      const elementBottom = rect.bottom;
      
      // Calculate position relative to viewport
      // Elements at bottom (not yet scrolled to) are foggy
      // Elements in upper portion (scrolled into view) are clear
      
      const fogThreshold = viewportHeight * 0.6; // Bottom 40% of viewport is foggy
      
      // Remove existing fog classes
      element.classList.remove('fog-clear', 'fog-distant');
      
      if (elementTop < fogThreshold) {
        // Crystal clear - scrolled into upper viewport
        element.classList.add('fog-clear');
      } else {
        // Foggy - far from focus
        element.classList.add('fog-distant');
      }
    });
  };

  // Apply on scroll - NO debouncing for instant response
  const handleScroll = () => {
    applyFogEffect();
  };

  // Apply on load and scroll
  applyFogEffect();
  window.addEventListener('scroll', handleScroll, { passive: true });
  
  // Also apply when scrolling within elements (like chat-messages)
  const scrollContainers = document.querySelectorAll('.chat-messages, .settings-container, .documents-container');
  scrollContainers.forEach(container => {
    container.addEventListener('scroll', handleScroll, { passive: true });
  });

  // Reapply when window resizes
  window.addEventListener('resize', applyFogEffect);

  // Return cleanup function
  return () => {
    window.removeEventListener('scroll', handleScroll);
    window.removeEventListener('resize', applyFogEffect);
    scrollContainers.forEach(container => {
      container.removeEventListener('scroll', handleScroll);
    });
  };
};
